import CircleWarningIcon from '@assets/icons/circle-warning.svg';
import i18n from '@/utils/i18n';
import {
  Button,
  ButtonProps,
  ButtonSize,
  ButtonVariant,
} from '@/experiences/sales-portal/components/button';
import { EmptyState } from '@experiences/components/empty-state';
import { StyleProp, ViewStyle } from 'react-native';
import { useTheme } from '@/contexts/theme-context';

interface ErrorStateProps {
  buttonLabel?: string;
  containerStyle?: StyleProp<ViewStyle>;
  ctaProps?: Partial<ButtonProps>;
  description: string;
  icon?: React.ReactNode;
  onPress: () => void;
  title: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  buttonLabel = i18n.t('sales_portal.error.retry'),
  containerStyle,
  ctaProps,
  description,
  icon,
  onPress,
  title,
}) => {
  const theme = useTheme();

  return (
    <EmptyState
      bottomElement={
        <Button
          accessibilityLabel={buttonLabel}
          onPress={onPress}
          size={ButtonSize.Medium}
          variant={ButtonVariant.Secondary}
          width={120}
          {...ctaProps}
        >
          {buttonLabel}
        </Button>
      }
      containerStyle={containerStyle}
      description={description}
      iconElement={
        icon ?? <CircleWarningIcon stroke={theme.sk.color.icon.primary} />
      }
      title={title}
    />
  );
};
